/**
 * Pixel breakpoint values for use in JavaScript logic and CSS variable injection.
 *
 * For responsive state in components, use the `useDeviceLayout` hook —
 * do not match against these values directly in component code.
 *
 * BREAKPOINTS_CSS_VARS is used during app initialization to inject breakpoints
 * as CSS custom properties on the current app root (e.g. --bim-breakpoint-tablet: 1023px).
 */
export const BREAKPOINTS = {
  // Desktop
  DESKTOP_XL: 1920,   // Full HD displays
  DESKTOP_L:  1536,   // 1920px at 125% zoom
  DESKTOP_M:  1440,   // Standard laptop
  DESKTOP_S:  1366,   // Smaller laptops
  DESKTOP_XS: 1280,   // Minimum desktop

  // Tablet / transition
  TABLET_L: 1179,     // Large tablets (iPad Air landscape)
  TABLET:   1023,     // Standard tablet breakpoint (iPad landscape)
  TABLET_S:  820,     // Tablets portrait (iPad Air)

  // Mobile
  MOBILE_L: 767,      // Large phones / small tablets
  MOBILE_M: 480,      // Standard phones
  MOBILE_S: 375,      // Small phones
}

/**
 * CSS custom property map derived from BREAKPOINTS.
 * Keys follow the `--bim-breakpoint-{name}` convention.
 * Inject onto the app root via useThemeVars during app initialization.
 *
 * @type {Record<string, string>}
 *
 * @example
 * // Result: { '--bim-breakpoint-tablet': '1023px', ... }
 */
export const BREAKPOINTS_CSS_VARS = Object.entries(BREAKPOINTS).reduce(
  (acc, [key, value]) => {
    acc[`--bim-breakpoint-${key.toLowerCase().replace(/_/g, '-')}`] = `${value}px`
    return acc
  },
  {}
)
